import React from "react";

const FieldLabel = (props) => {
  return (
    <div className="row field-label pr-8 d-flex flex-column">
      <label>Field Label*</label>
      <input
        type="text"
        maxLength="2000"
        placeholder="Field Label"
        value={props.value}
        onChange={props.changeHandler}
        className={props.errors[props.idValue] ? "error-input" : ""}
      />
      {props.errors[props.idValue] && (
        <label className="error">Mandatory Field.</label>
      )}
    </div>
  );
};

export default FieldLabel;
